// axiosInstance, not the cachios client — a stale copy would keep showing
// an application the student just finished
import {axiosInstance as http} from "@/http_client";

/**
 * The student's certificate records (app/users/certificates): completed
 * certificates plus applications started and not finished. One source for
 * the Certificates & Forms page AND the section menu, so "In Progress
 * Applications" shows exactly when that page would list something.
 */
let pending = null;
let availablePending = null;

// Available Applications statuses (api getAvailableApplications) that count
// as "ready" — matches the page's "Ready to Apply" section. Conference
// `requirements` items are left out: they may not be met yet.
export const READY_AVAILABLE_STATUSES = ['ready'];

export default {
    state: {
        certificates: null,   // null until loaded
        certifications: [],
        // Applications/forms offered and not started (app/users/available-applications)
        availableApplications: null,   // null until loaded
    },
    getters: {
        certificates: state => state.certificates,
        certificateCertifications: state => state.certifications,
        certificatesLoaded: state => state.certificates !== null,
        inProgressApplicationCount: state => (state.certificates || []).filter(c => c.status === 'in_progress').length,
        availableApplications: state => state.availableApplications,
        availableApplicationsLoaded: state => state.availableApplications !== null,
        // Ready to apply, leaving out certifications the student switched off
        readyApplicationCount: (state, getters, rootState, rootGetters) => (state.availableApplications || [])
            .filter(a => READY_AVAILABLE_STATUSES.includes(a.status) && (!a.certification || rootGetters.certificationOn(a.certification.id)))
            .length,
    },
    mutations: {
        setCertificates(state, {certificates, certifications}) {
            state.certificates = certificates || [];
            state.certifications = certifications || [];
        },
        setAvailableApplications(state, applications) {
            state.availableApplications = applications || [];
        }
    },
    actions: {
        // The top bar and side menu both ask on mount; share one request
        getCertificates({commit}) {
            if (!pending) {
                pending = http.get('app/users/certificates').then(response => {
                    commit('setCertificates', response.data || {});
                    return response.data;
                }).finally(() => { pending = null; });
            }
            return pending;
        },
        // The side menu's "N Ready to Apply" tag and the page share one list
        getAvailableApplications({commit}) {
            if (!availablePending) {
                availablePending = http.get('app/users/available-applications').then(response => {
                    commit('setAvailableApplications', response.data.applications);
                    return response.data.applications;
                }).finally(() => { availablePending = null; });
            }
            return availablePending;
        }
    }
};
